import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "search-code-form"
};
const _hoisted_2 = {
  class: "localized-text"
};
import { onMounted, ref } from "vue";
import { searchCode } from "@/utils/tools";
// import { useI18n } from "vue-i18n";
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
import { useOverlayStore } from "@/stores";
export default /*@__PURE__*/_defineComponent({
  __name: 'searchCode',
  emits: ["switchMainProduct"],
  setup(__props, {
    emit: __emit
  }) {
    const attribute = useAdditionalAttrStore();
    const overlay = useOverlayStore();
    const code = ref(attribute.dataConfig.buildId ?? "");
    const emit = __emit;
    const handleSearch = async closeLoading => {
      if (code.value != "") {
        if (typeof closeLoading === "undefined") {
          closeLoading = true;
        }
        await searchCode(code.value, closeLoading, () => {
          emit("switchMainProduct");
        }, () => {
          overlay.setshowShortcodeError(true);
        });
        code.value = "";
      }
    };
    onMounted(() => {
      if (attribute.dataConfig.buildId) {
        handleSearch(false);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h4", null, _toDisplayString(_ctx.$t("search.code.heading")), 1), _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("search.code.text")), 1), _createVNode(_component_el_input, {
        modelValue: code.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => code.value = $event),
        placeholder: _ctx.$t('search.buildId'),
        maxlength: "10",
        onKeyup: _cache[2] || (_cache[2] = _withKeys($event => handleSearch(true), ["enter"]))
      }, {
        prefix: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("i", {
          class: "iconfont icon-search"
        }, null, -1)]))]),
        append: _withCtx(() => [_createVNode(_component_el_button, {
          class: "has-text-white",
          onClick: _cache[0] || (_cache[0] = $event => handleSearch(true))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("button.ok")), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "placeholder"])]);
    };
  }
});